import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  GetBackofficeSupportActivitySchema,
  GetSupportActivityResponseDataSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeSupportActivitySchema>
type Response = DataResponse<z.infer<typeof GetSupportActivityResponseDataSchema>>

const getBackofficeSupportActivityQueryKey = (query: Query) => ["backofficeSupportActivity", query]

type Props = {
  query: Query
  enabled?: boolean
}

export const getBackofficeSupportActivityQuery = ({ query, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getBackofficeSupportActivityQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/support/activity", {
        params: query,
      })
      return data.data
    },
    enabled,
  })
}
